// src/app/environment.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export type EnvConfig = {
  APP_VERSION: string;
  ENV: string;
};

@Injectable({ providedIn: 'root' })
export class EnvService {
  private http = inject(HttpClient);

  private env: EnvConfig;

  public async loadEnvironment(): Promise<void> {
    const randomParam = Math.random().toString(36).substring(2, 15);
    const envData = await firstValueFrom(
      this.http.get(`/assets/env.json?v=${randomParam}`),
    );
    this.env = envData as EnvConfig;
  }

  get APP_VERSION(): string {
    return this.env?.APP_VERSION;
  }

  get ENV(): string {
    return this.env?.ENV;
  }
}
